// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"8c3aa193","213":"9e7bde2b","475":"c56fd910","580":"2075ab70","591":"f0938731","747":"9a57d74c"}[chunkId] + ".chunk.js";
};